import type { FC } from 'react';
import { IpcButton, IpcModal } from '../components/ui';
import {
  NODE_CONTEXT_FIELD_DOCS,
  RULE_SCRIPT_CONTEXT_KEYS,
} from '../types/nodeAutoCompleteRuleScriptContext';
import './NodeAutoCompletePrepareScriptHelpModal.css';

type Props = {
  open: boolean;
  onClose: () => void;
};

const EXAMPLE_SCRIPT = `function execute(context, services) {
  const preparedData = context.preparedData;
  const nodeContext = context.nodeContext;

  if (preparedData && preparedData.ready === true) {
    return { action: 'complete_node' };
  }
  return { action: 'noop' };
}`;

const NodeAutoCompleteDecisionScriptHelpModal: FC<Props> = ({ open, onClose }) => (
  <IpcModal
    open={open}
    title="动作决策脚本说明"
    width={760}
    onCancel={onClose}
    footer={(
      <div className="ipc-modal__footer-actions">
        <IpcButton variant="primary" onClick={onClose}>关闭</IpcButton>
      </div>
    )}
    className="acr-script-help-modal"
  >
    <div className="acr-script-help">
      <section className="acr-script-help__section">
        <h4 className="acr-script-help__heading">脚本约定</h4>
        <p className="acr-script-help__text">
          请编写入口函数 <code>execute(context, services)</code>。根据数据准备结果与节点上下文，
          返回决策对象，例如 <code>{'{ action: "complete_node" }'}</code> 或 <code>{'{ action: "noop" }'}</code>。
        </p>
        <pre className="acr-script-help__code">{EXAMPLE_SCRIPT}</pre>
      </section>

      <section className="acr-script-help__section">
        <h4 className="acr-script-help__heading">context 入参（第 3 步）</h4>
        <p className="acr-script-help__text">
          动作决策步骤的 <code>context</code> 包含第 2 步的全部字段，并额外增加数据准备返回值：
        </p>
        <dl className="acr-script-help__dl">
          <div>
            <dt><code>context.{RULE_SCRIPT_CONTEXT_KEYS.triggerPayload}</code></dt>
            <dd>
              与第 2 步相同。接口正式触发为
              <code>{'{'} trigger_key, content {'}'}</code>
              ；MQ 为
              <code>{'{'} vhost, queue, content {'}'}</code>。
            </dd>
          </div>
          <div>
            <dt><code>context.{RULE_SCRIPT_CONTEXT_KEYS.nodeContext}</code></dt>
            <dd>与第 2 步相同，排期节点相关数据。</dd>
          </div>
          <div>
            <dt><code>context.{RULE_SCRIPT_CONTEXT_KEYS.preparedData}</code></dt>
            <dd>第 2 步「数据准备」脚本的返回值；若返回 <code>null</code> 则为 <code>null</code>。</dd>
          </div>
        </dl>
        <p className="acr-script-help__text">nodeContext 常见字段：</p>
        <ul className="acr-script-help__field-list">
          {NODE_CONTEXT_FIELD_DOCS.map(item => (
            <li key={item.field}>
              <code>{item.field}</code>
              <span>{item.description}</span>
            </li>
          ))}
        </ul>
      </section>

      <section className="acr-script-help__section">
        <h4 className="acr-script-help__heading">返回值</h4>
        <p className="acr-script-help__text">
          建议返回 <code>{'{ action: "complete_node" }'}</code> 表示执行节点完成，
          或 <code>{'{ action: "noop" }'}</code> 表示不执行任何动作。
        </p>
      </section>
    </div>
  </IpcModal>
);

export default NodeAutoCompleteDecisionScriptHelpModal;
